import {createStore, combineReducers, applyMiddleware} from 'redux';

import {language} from "./language";
import {user} from "./user";
import {isAuthorized} from "./authorization";
import {championships} from "./championships";
import {rating} from "./rating";
import {champs} from "./champs";
import {vacancies} from "./vacancies";
import {drafts} from './article';
import {forum} from './forum';

const logger = store => next => action => {
    let result;
/*    console.groupCollapsed("dispatching", action.type);
    console.log('prev state', store.getState());
    console.log('action', action);*/
    result = next(action);
/*    console.log('next state', store.getState());
    console.groupEnd();*/
    return result;
};

const saver = store => next => action => {
    let result = next(action);
    localStorage[process.env.LOCAL_STORAGE] = JSON.stringify(store.getState());
    return result;
};

const pick = (obj, ...keys) => ({
    ...keys.reduce((res, e) => obj[e] !== undefined ? {...res, [e]:obj[e]} : {...res}, {})
});

const initStorage = (initialState = {}) => {
    //console.log('local storage', JSON.parse(localStorage.getItem(process.env.LOCAL_STORAGE)));
    //console.log(initialState);
    //localStorage.setItem(process.env.LOCAL_STORAGE, JSON.stringify(initialState));
    const item = JSON.parse(localStorage.getItem(process.env.LOCAL_STORAGE));
    //console.log('STORAGE ITEM', item);
    if (
        item && 
        item.forum && 
        item.user && 
        item.user.forum && 
        Object.keys(pick(item.forum, ...Object.keys(initialState.forum))).length == Object.keys(initialState.forum).length &&
        Object.keys(pick(item.user.forum, ...Object.keys(initialState.user.forum))).length == Object.keys(initialState.user.forum).length && 
        !item.user.forum.commends && 
        item.forum.commends && 
        !item.user.forum.bookmarks
    ) {
        //console.log('local storage is not null');
        return item;
    } else {
        localStorage.setItem(process.env.LOCAL_STORAGE, JSON.stringify(initialState));
        return initialState;
    }
};

export const storeFactory = (initialState = {}) => {
    //console.log('INITIAL STATE', initialState);
    return (
        applyMiddleware(logger, saver)(createStore)(
            combineReducers({
                persistStore:
                    combineReducers({
                        language,
                        isAuthorized,
                    }),
                user,
                championships,
                rating,
                champs,
                vacancies,
                //OLD CODE, KEPT JUST IN CASE
                /*drafts,*/
                forum,
            }),
            initStorage(initialState)
        )
    );
};



// WEBPACK FOOTER //
// src/reducers/index.jsx